import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type AlarmConfigurationDto = {
  __typename?: 'AlarmConfigurationDto';
  alarmCondition?: Maybe<Scalars['Boolean']['output']>;
  alarmMinutesPeriod?: Maybe<Scalars['Float']['output']>;
  alarmType: AlarmTypeEnum;
  alarmValue?: Maybe<Scalars['Decimal']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  distributionBoardId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isOptional: Scalars['Boolean']['output'];
  notificationType: NotificationTypeEnum;
  slotName?: Maybe<Scalars['String']['output']>;
};

export type AlarmDescriptionDto = {
  __typename?: 'AlarmDescriptionDto';
  descriptionArguments?: Maybe<Array<Scalars['String']['output']>>;
  descriptionCode: AlarmDescriptionEnum;
};

export enum AlarmDescriptionEnum {
  BoolOkNok = 'BOOL_OK_NOK',
  BoolOnOff = 'BOOL_ON_OFF',
  BoolYesNo = 'BOOL_YES_NO',
  CommunicationLost = 'COMMUNICATION_LOST',
  ContractExpired = 'CONTRACT_EXPIRED',
  CountChange = 'COUNT_CHANGE',
  ValueGreaterThan = 'VALUE_GREATER_THAN',
  ValueLessThan = 'VALUE_LESS_THAN',
  ValueTimestamp = 'VALUE_TIMESTAMP'
}

export type AlarmDto = {
  __typename?: 'AlarmDto';
  code?: Maybe<Scalars['String']['output']>;
  description: AlarmDescriptionDto;
  distributionBoardId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isAcknowledged: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  status: AlarmStatusEnum;
  timestamp: Scalars['DateTime']['output'];
  type: AlarmTypeEnum;
};

export enum AlarmStatusEnum {
  Acknowledged = 'ACKNOWLEDGED',
  Activated = 'ACTIVATED',
  Deactivated = 'DEACTIVATED'
}

export enum AlarmTypeEnum {
  Bool = 'BOOL',
  CommunicationLost = 'COMMUNICATION_LOST',
  ContractExpired = 'CONTRACT_EXPIRED',
  CountChange = 'COUNT_CHANGE',
  ValueGreaterThan = 'VALUE_GREATER_THAN',
  ValueLessThan = 'VALUE_LESS_THAN',
  ValueTimestamp = 'VALUE_TIMESTAMP'
}

export type ApplicationError = {
  __typename?: 'ApplicationError';
  code?: Maybe<Scalars['String']['output']>;
  extensions?: Maybe<ApplicationErrorExtensions>;
  message: Scalars['String']['output'];
  path?: Maybe<Array<Scalars['String']['output']>>;
};

export type ApplicationErrorExtensions = {
  __typename?: 'ApplicationErrorExtensions';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export enum CategoryEnum {
  Global = 'GLOBAL',
  HeatPump = 'HEAT_PUMP',
  Pump1 = 'PUMP1',
  Pump2 = 'PUMP2',
  Setting = 'SETTING',
  Statistic = 'STATISTIC'
}

export type ClientDto = {
  __typename?: 'ClientDto';
  dateCreated: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum CommunicationModuleEnum {
  Ethernet = 'ETHERNET',
  Gprs = 'GPRS',
  Wifi = 'WIFI'
}

export type ComponentDto = {
  __typename?: 'ComponentDto';
  category: CategoryEnum;
  componentFormat: ComponentFormatEnum;
  componentLogicalName?: Maybe<ComponentLogicalNameEnum>;
  componentType: ComponentTypeEnum;
  description: Scalars['String']['output'];
  isEditable: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['Int']['output']>;
  slotName: Scalars['String']['output'];
  targetValue?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ComponentFormatEnum {
  AmperageSensor = 'AMPERAGE_SENSOR',
  CommunicationModule = 'COMMUNICATION_MODULE',
  Controller = 'CONTROLLER',
  DigitalInput = 'DIGITAL_INPUT',
  Display = 'DISPLAY',
  Dummy = 'DUMMY',
  LevelSensor1 = 'LEVEL_SENSOR1',
  LevelSensor2 = 'LEVEL_SENSOR2',
  LevelSensor3 = 'LEVEL_SENSOR3',
  Module = 'MODULE',
  PressureSensor = 'PRESSURE_SENSOR',
  Relay = 'RELAY',
  VirtualFactor1Number = 'VIRTUAL_FACTOR1_NUMBER',
  VirtualFactor6Number = 'VIRTUAL_FACTOR6_NUMBER',
  VirtualFactor10Bar = 'VIRTUAL_FACTOR10_BAR',
  VirtualFactor10Number = 'VIRTUAL_FACTOR10_NUMBER',
  VirtualFactor100Number = 'VIRTUAL_FACTOR100_NUMBER',
  VirtualFactor300Number = 'VIRTUAL_FACTOR300_NUMBER',
  VirtualFactor1000Number = 'VIRTUAL_FACTOR1000_NUMBER',
  VirtualInput7_5Number = 'VIRTUAL_INPUT7_5_NUMBER',
  VirtualInput30Number = 'VIRTUAL_INPUT30_NUMBER',
  VirtualInput33_333Number = 'VIRTUAL_INPUT33_333_NUMBER',
  VirtualInput50Number = 'VIRTUAL_INPUT50_NUMBER',
  VirtualInput60Number = 'VIRTUAL_INPUT60_NUMBER',
  VirtualInput100Number = 'VIRTUAL_INPUT100_NUMBER',
  VirtualInput120Number = 'VIRTUAL_INPUT120_NUMBER',
  VirtualInput150Number = 'VIRTUAL_INPUT150_NUMBER',
  VirtualInput187_5Number = 'VIRTUAL_INPUT187_5_NUMBER',
  VirtualInput300Number = 'VIRTUAL_INPUT300_NUMBER',
  VirtualInput500Number = 'VIRTUAL_INPUT500_NUMBER',
  VirtualInput600Number = 'VIRTUAL_INPUT600_NUMBER',
  VirtualInput750Number = 'VIRTUAL_INPUT750_NUMBER',
  VirtualInput1000Number = 'VIRTUAL_INPUT1000_NUMBER',
  VirtualInput1500Number = 'VIRTUAL_INPUT1500_NUMBER',
  VirtualInput3000Number = 'VIRTUAL_INPUT3000_NUMBER',
  VirtualOkNokBool = 'VIRTUAL_OK_NOK_BOOL',
  VirtualOnOffBool = 'VIRTUAL_ON_OFF_BOOL',
  VirtualYesNoBool = 'VIRTUAL_YES_NO_BOOL',
  VoltageSensor = 'VOLTAGE_SENSOR'
}

export enum ComponentLogicalNameEnum {
  BoreholeLevel = 'BOREHOLE_LEVEL',
  BoreholeLevelLow = 'BOREHOLE_LEVEL_LOW',
  BoreholeLevelLowProtectionLimit = 'BOREHOLE_LEVEL_LOW_PROTECTION_LIMIT',
  BoreholeLevelMaxLimit = 'BOREHOLE_LEVEL_MAX_LIMIT',
  BoreholeLevelMeasurement = 'BOREHOLE_LEVEL_MEASUREMENT',
  BoreholeLevelMinLimit = 'BOREHOLE_LEVEL_MIN_LIMIT',
  EnableEditing = 'ENABLE_EDITING',
  HeatPumpCommand = 'HEAT_PUMP_COMMAND',
  HeatPumpFilter = 'HEAT_PUMP_FILTER',
  HeatPumpPresent = 'HEAT_PUMP_PRESENT',
  ModuleForAnalogInputs = 'MODULE_FOR_ANALOG_INPUTS',
  PowerSupplyModuleForAnalogInputs = 'POWER_SUPPLY_MODULE_FOR_ANALOG_INPUTS',
  Pressure = 'PRESSURE',
  PressureHighLimit = 'PRESSURE_HIGH_LIMIT',
  PressureLowLimit = 'PRESSURE_LOW_LIMIT',
  PressureMeasurement = 'PRESSURE_MEASUREMENT',
  Pump1Command = 'PUMP1_COMMAND',
  Pump1Contactor = 'PUMP1_CONTACTOR',
  Pump1Current = 'PUMP1_CURRENT',
  Pump1CurrentMeasurement = 'PUMP1_CURRENT_MEASUREMENT',
  Pump1EmergencyStop = 'PUMP1_EMERGENCY_STOP',
  Pump1MotorProtection = 'PUMP1_MOTOR_PROTECTION',
  Pump2Command = 'PUMP2_COMMAND',
  Pump2Contactor = 'PUMP2_CONTACTOR',
  Pump2Current = 'PUMP2_CURRENT',
  Pump2CurrentMeasurement = 'PUMP2_CURRENT_MEASUREMENT',
  Pump2EmergencyStop = 'PUMP2_EMERGENCY_STOP',
  Pump2MotorProtection = 'PUMP2_MOTOR_PROTECTION',
  Pump2Present = 'PUMP2_PRESENT',
  TankLevel = 'TANK_LEVEL',
  TankLevelHighLimit = 'TANK_LEVEL_HIGH_LIMIT',
  TankLevelLow = 'TANK_LEVEL_LOW',
  TankLevelLowLimit = 'TANK_LEVEL_LOW_LIMIT',
  TankLevelLowProtectionLimit = 'TANK_LEVEL_LOW_PROTECTION_LIMIT',
  TankLevelMaxLimit = 'TANK_LEVEL_MAX_LIMIT',
  TankLevelMeasurement = 'TANK_LEVEL_MEASUREMENT',
  TankLevelMinLimit = 'TANK_LEVEL_MIN_LIMIT',
  Voltage = 'VOLTAGE',
  VoltageHigh = 'VOLTAGE_HIGH',
  VoltageHighLimit = 'VOLTAGE_HIGH_LIMIT',
  VoltageLowLimit = 'VOLTAGE_LOW_LIMIT',
  VoltageMeasurement = 'VOLTAGE_MEASUREMENT'
}

export enum ComponentTypeEnum {
  ReadOnly = 'READ_ONLY',
  ReadWrite = 'READ_WRITE',
  Static = 'STATIC'
}

export type CreateClientInput = {
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateLocationInput = {
  address: Scalars['String']['input'];
  clientId: Scalars['UUID']['input'];
  contractDate: Scalars['DateTime']['input'];
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateUserInput = {
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  role: UserRoleEnum;
};

export enum DisplayEnum {
  FourInch = 'FOUR_INCH',
  None = 'NONE',
  SevenInch = 'SEVEN_INCH',
  TenInch = 'TEN_INCH'
}

export type DistributionBoardComponentDto = {
  __typename?: 'DistributionBoardComponentDto';
  channelCode?: Maybe<Scalars['String']['output']>;
  connectorCode?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  factor?: Maybe<Scalars['Decimal']['output']>;
  format: ComponentFormatEnum;
  fuseSpec: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  rangeFrom?: Maybe<Scalars['Decimal']['output']>;
  rangeTo?: Maybe<Scalars['Decimal']['output']>;
  units: UnitEnum;
};

export type DistributionBoardDto = {
  __typename?: 'DistributionBoardDto';
  boardComponents: Array<DistributionBoardComponentDto>;
  communicationModule: CommunicationModuleEnum;
  display: DisplayEnum;
  id: Scalars['UUID']['output'];
  locationId: Scalars['UUID']['output'];
  powerSupply: Scalars['String']['output'];
  template: TemplateEnum;
  virtualComponents: Array<VirtualComponentDto>;
};

export type DistributionBoardSettingsDto = {
  __typename?: 'DistributionBoardSettingsDto';
  emergencyStopPump1: Scalars['Boolean']['output'];
  emergencyStopPump2: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  sendInterval: Scalars['Int']['output'];
};

export enum ErrorMessages {
  AlarmConfigurationNotFound = 'ALARM_CONFIGURATION_NOT_FOUND',
  AlarmNotFound = 'ALARM_NOT_FOUND',
  CantDeserializeProcessedData = 'CANT_DESERIALIZE_PROCESSED_DATA',
  ClientNotFound = 'CLIENT_NOT_FOUND',
  DistributionBoardNotFound = 'DISTRIBUTION_BOARD_NOT_FOUND',
  FieldMaxLength = 'FIELD_MAX_LENGTH',
  FieldMinLength = 'FIELD_MIN_LENGTH',
  FieldMustNotBeNull = 'FIELD_MUST_NOT_BE_NULL',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidRefreshToken = 'INVALID_REFRESH_TOKEN',
  LocationNotFound = 'LOCATION_NOT_FOUND',
  NotEmptyField = 'NOT_EMPTY_FIELD',
  NotValidEmail = 'NOT_VALID_EMAIL',
  PasswordExpired = 'PASSWORD_EXPIRED',
  PasswordMinimumLength = 'PASSWORD_MINIMUM_LENGTH',
  UserDoesNotHaveAssignedClient = 'USER_DOES_NOT_HAVE_ASSIGNED_CLIENT',
  UserNotFound = 'USER_NOT_FOUND',
  UserWrongRole = 'USER_WRONG_ROLE',
  WrongEmailOrPassword = 'WRONG_EMAIL_OR_PASSWORD'
}

export type FormattedDataDto = {
  __typename?: 'FormattedDataDto';
  slot1?: Maybe<Scalars['String']['output']>;
  slot2?: Maybe<Scalars['String']['output']>;
  slot3?: Maybe<Scalars['String']['output']>;
  slot4?: Maybe<Scalars['String']['output']>;
  slot5?: Maybe<Scalars['String']['output']>;
  slot6?: Maybe<Scalars['String']['output']>;
  slot7?: Maybe<Scalars['String']['output']>;
  slot8?: Maybe<Scalars['String']['output']>;
  slot9?: Maybe<Scalars['String']['output']>;
  slot10?: Maybe<Scalars['String']['output']>;
  slot11?: Maybe<Scalars['String']['output']>;
  slot12?: Maybe<Scalars['String']['output']>;
  slot13?: Maybe<Scalars['String']['output']>;
  slot14?: Maybe<Scalars['String']['output']>;
  slot15?: Maybe<Scalars['String']['output']>;
  slot16?: Maybe<Scalars['String']['output']>;
  slot17?: Maybe<Scalars['String']['output']>;
  slot18?: Maybe<Scalars['String']['output']>;
  slot19?: Maybe<Scalars['String']['output']>;
  slot20?: Maybe<Scalars['String']['output']>;
  slot21?: Maybe<Scalars['String']['output']>;
  slot22?: Maybe<Scalars['String']['output']>;
  slot23?: Maybe<Scalars['String']['output']>;
  slot24?: Maybe<Scalars['String']['output']>;
  slot25?: Maybe<Scalars['String']['output']>;
  slot26?: Maybe<Scalars['String']['output']>;
  slot27?: Maybe<Scalars['String']['output']>;
  slot28?: Maybe<Scalars['String']['output']>;
  slot29?: Maybe<Scalars['String']['output']>;
  slot30?: Maybe<Scalars['String']['output']>;
  slot31?: Maybe<Scalars['String']['output']>;
  slot32?: Maybe<Scalars['String']['output']>;
  slot33?: Maybe<Scalars['String']['output']>;
  slot34?: Maybe<Scalars['String']['output']>;
  slot35?: Maybe<Scalars['String']['output']>;
  slot36?: Maybe<Scalars['String']['output']>;
  slot37?: Maybe<Scalars['String']['output']>;
  slot38?: Maybe<Scalars['String']['output']>;
  slot39?: Maybe<Scalars['String']['output']>;
  slot40?: Maybe<Scalars['String']['output']>;
  slot41?: Maybe<Scalars['String']['output']>;
  slot42?: Maybe<Scalars['String']['output']>;
  slot43?: Maybe<Scalars['String']['output']>;
  slot44?: Maybe<Scalars['String']['output']>;
  slot45?: Maybe<Scalars['String']['output']>;
  slot46?: Maybe<Scalars['String']['output']>;
  slot47?: Maybe<Scalars['String']['output']>;
  slot48?: Maybe<Scalars['String']['output']>;
  slot49?: Maybe<Scalars['String']['output']>;
  slot50?: Maybe<Scalars['String']['output']>;
  slot51?: Maybe<Scalars['String']['output']>;
  slot52?: Maybe<Scalars['String']['output']>;
  slot53?: Maybe<Scalars['String']['output']>;
  slot54?: Maybe<Scalars['String']['output']>;
  slot55?: Maybe<Scalars['String']['output']>;
  slot56?: Maybe<Scalars['String']['output']>;
  slot57?: Maybe<Scalars['String']['output']>;
  slot58?: Maybe<Scalars['String']['output']>;
  slot59?: Maybe<Scalars['String']['output']>;
  slot60?: Maybe<Scalars['String']['output']>;
  slot61?: Maybe<Scalars['String']['output']>;
  slot62?: Maybe<Scalars['String']['output']>;
  slot63?: Maybe<Scalars['String']['output']>;
  slot64?: Maybe<Scalars['String']['output']>;
  slot65?: Maybe<Scalars['String']['output']>;
  slot66?: Maybe<Scalars['String']['output']>;
  slot67?: Maybe<Scalars['String']['output']>;
  slot68?: Maybe<Scalars['String']['output']>;
  slot69?: Maybe<Scalars['String']['output']>;
  slot70?: Maybe<Scalars['String']['output']>;
  slot71?: Maybe<Scalars['String']['output']>;
  slot72?: Maybe<Scalars['String']['output']>;
  slot73?: Maybe<Scalars['String']['output']>;
  slot74?: Maybe<Scalars['String']['output']>;
  slot75?: Maybe<Scalars['String']['output']>;
  slot76?: Maybe<Scalars['String']['output']>;
  slot77?: Maybe<Scalars['String']['output']>;
  slot78?: Maybe<Scalars['String']['output']>;
  slot79?: Maybe<Scalars['String']['output']>;
  slot80?: Maybe<Scalars['String']['output']>;
  slot81?: Maybe<Scalars['String']['output']>;
  slot82?: Maybe<Scalars['String']['output']>;
  slot83?: Maybe<Scalars['String']['output']>;
  slot84?: Maybe<Scalars['String']['output']>;
  slot85?: Maybe<Scalars['String']['output']>;
  slot86?: Maybe<Scalars['String']['output']>;
  slot87?: Maybe<Scalars['String']['output']>;
  slot88?: Maybe<Scalars['String']['output']>;
  slot89?: Maybe<Scalars['String']['output']>;
  slot90?: Maybe<Scalars['String']['output']>;
  slot91?: Maybe<Scalars['String']['output']>;
  slot92?: Maybe<Scalars['String']['output']>;
  slot93?: Maybe<Scalars['String']['output']>;
  slot94?: Maybe<Scalars['String']['output']>;
  slot95?: Maybe<Scalars['String']['output']>;
  slot96?: Maybe<Scalars['String']['output']>;
  slot97?: Maybe<Scalars['String']['output']>;
  slot98?: Maybe<Scalars['String']['output']>;
  slot99?: Maybe<Scalars['String']['output']>;
  slot100?: Maybe<Scalars['String']['output']>;
  slot101?: Maybe<Scalars['String']['output']>;
  slot102?: Maybe<Scalars['String']['output']>;
  slot103?: Maybe<Scalars['String']['output']>;
  slot104?: Maybe<Scalars['String']['output']>;
  slot105?: Maybe<Scalars['String']['output']>;
  slot106?: Maybe<Scalars['String']['output']>;
  slot107?: Maybe<Scalars['String']['output']>;
  slot108?: Maybe<Scalars['String']['output']>;
  slot109?: Maybe<Scalars['String']['output']>;
  slot110?: Maybe<Scalars['String']['output']>;
  slot111?: Maybe<Scalars['String']['output']>;
  slot112?: Maybe<Scalars['String']['output']>;
  slot113?: Maybe<Scalars['String']['output']>;
};

export type HistoryDto = {
  __typename?: 'HistoryDto';
  formattedData?: Maybe<FormattedDataDto>;
  id: Scalars['UUID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type LocationByClientIdDto = {
  __typename?: 'LocationByClientIdDto';
  address: Scalars['String']['output'];
  clientId: Scalars['UUID']['output'];
  contractDate: Scalars['DateTime']['output'];
  distributionBoardId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LocationDto = {
  __typename?: 'LocationDto';
  address: Scalars['String']['output'];
  clientId: Scalars['UUID']['output'];
  contractDate: Scalars['DateTime']['output'];
  distributionBoardId: Scalars['UUID']['output'];
  hasActiveContract: Scalars['Boolean']['output'];
  hasAlarm: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  mobile: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MetricDto = {
  __typename?: 'MetricDto';
  components?: Maybe<Array<ComponentDto>>;
  distributionBoardId: Scalars['UUID']['output'];
  editingEnabled: Scalars['Boolean']['output'];
  enableSaveFunction: Scalars['Boolean']['output'];
  firstPackageReceived?: Maybe<Scalars['DateTime']['output']>;
  fistPackageAfterCommunicationRestore?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type Mutations = {
  __typename?: 'Mutations';
  createClient: ClientDto;
  createLocation: LocationByClientIdDto;
  createUser: UserDto;
  deactivateUser: UserDto;
  deleteClient: ClientDto;
  deleteLocation: LocationByClientIdDto;
  deleteUser: UserDto;
  inviteUser: UserDto;
  toggleDistributionBoardSendInterval: Scalars['Boolean']['output'];
  updateAlarm: AlarmDto;
  updateAlarmConfiguration: AlarmConfigurationDto;
  updateClient: ClientDto;
  updateDistributionBoard: DistributionBoardDto;
  updateDistributionBoardSettings: DistributionBoardSettingsDto;
  updateLocation: LocationByClientIdDto;
};


export type MutationsCreateClientArgs = {
  input: CreateClientInput;
};


export type MutationsCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationsCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationsDeactivateUserArgs = {
  id: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationsDeleteClientArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationsDeleteLocationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationsDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationsInviteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationsToggleDistributionBoardSendIntervalArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationsUpdateAlarmArgs = {
  input: UpdateAlarmInput;
};


export type MutationsUpdateAlarmConfigurationArgs = {
  input: UpdateAlarmConfigurationInput;
};


export type MutationsUpdateClientArgs = {
  input: UpdateClientInput;
};


export type MutationsUpdateDistributionBoardArgs = {
  input: UpdateDistributionBoardInput;
};


export type MutationsUpdateDistributionBoardSettingsArgs = {
  input: UpdateDistributionBoardSettingsInput;
};


export type MutationsUpdateLocationArgs = {
  input: UpdateLocationInput;
};

export type NotificationHistoryDto = {
  __typename?: 'NotificationHistoryDto';
  alarmType: AlarmTypeEnum;
  code: Scalars['String']['output'];
  distributionBoardId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  isSuccessfullySend: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  notificationType: NotificationTypeEnum;
  slotName?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export enum NotificationTypeEnum {
  Email = 'EMAIL',
  None = 'NONE',
  Sms = 'SMS'
}

export type Queries = {
  __typename?: 'Queries';
  alarmComponents: Array<ComponentDto>;
  alarmConfigurations: Array<AlarmConfigurationDto>;
  alarms: Array<AlarmDto>;
  alarmsHistory: Array<AlarmDto>;
  client: ClientDto;
  clients: Array<ClientDto>;
  distributionBoard: DistributionBoardDto;
  distributionBoardSettings: DistributionBoardSettingsDto;
  histories: Array<HistoryDto>;
  location: LocationByClientIdDto;
  locations: Array<LocationDto>;
  locationsByClientId: Array<LocationByClientIdDto>;
  metric: MetricDto;
  notificationHistory: Array<NotificationHistoryDto>;
  processedDataHeaderNames: Array<ComponentDto>;
  users: Array<UserDto>;
};


export type QueriesAlarmComponentsArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesAlarmConfigurationsArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesAlarmsArgs = {
  isAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['UUID']['input'];
};


export type QueriesAlarmsHistoryArgs = {
  locationId: Scalars['UUID']['input'];
  slotName?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesClientArgs = {
  id: Scalars['UUID']['input'];
};


export type QueriesClientsArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesDistributionBoardArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesDistributionBoardSettingsArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesHistoriesArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  locationId: Scalars['UUID']['input'];
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueriesLocationArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesLocationsArgs = {
  alarmsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  hasActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueriesLocationsByClientIdArgs = {
  clientId: Scalars['UUID']['input'];
};


export type QueriesMetricArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesNotificationHistoryArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesProcessedDataHeaderNamesArgs = {
  locationId: Scalars['UUID']['input'];
};


export type QueriesUsersArgs = {
  searchText?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateEnum {
  Template1 = 'TEMPLATE1',
  Template2 = 'TEMPLATE2',
  Template3 = 'TEMPLATE3',
  Template4 = 'TEMPLATE4',
  Template5 = 'TEMPLATE5',
  Template6 = 'TEMPLATE6'
}

export enum UnitEnum {
  A = 'A',
  Bar = 'BAR',
  Cm = 'CM',
  M = 'M',
  MA = 'M_A',
  Number = 'NUMBER',
  OkNok = 'OK_NOK',
  OnOff = 'ON_OFF',
  Other = 'OTHER',
  V = 'V',
  YesNo = 'YES_NO'
}

export type UpdateAlarmConfigurationInput = {
  alarmCondition?: InputMaybe<Scalars['Boolean']['input']>;
  alarmMinutesPeriod?: InputMaybe<Scalars['Float']['input']>;
  alarmType?: InputMaybe<AlarmTypeEnum>;
  alarmValue?: InputMaybe<Scalars['Decimal']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  notificationType?: InputMaybe<NotificationTypeEnum>;
  slotName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlarmInput = {
  id: Scalars['UUID']['input'];
  isAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateClientInput = {
  id: Scalars['UUID']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDistributionBoardComponentInput = {
  description: Scalars['String']['input'];
  format: ComponentFormatEnum;
  id: Scalars['UUID']['input'];
};

export type UpdateDistributionBoardInput = {
  communicationModule?: InputMaybe<CommunicationModuleEnum>;
  components?: InputMaybe<Array<UpdateDistributionBoardComponentInput>>;
  display?: InputMaybe<DisplayEnum>;
  id: Scalars['UUID']['input'];
  powerSupply?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<TemplateEnum>;
};

export type UpdateDistributionBoardSettingsInput = {
  distributionBoardId: Scalars['UUID']['input'];
  emergencyStopPump1?: InputMaybe<Scalars['Boolean']['input']>;
  emergencyStopPump2?: InputMaybe<Scalars['Boolean']['input']>;
  sendInterval?: InputMaybe<Scalars['Int']['input']>;
  setting?: InputMaybe<UpdateDistributionBoardSettingsValueInput>;
};

export type UpdateDistributionBoardSettingsValueInput = {
  slotName: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  contractDate?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['UUID']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserDto = {
  __typename?: 'UserDto';
  clientId?: Maybe<Scalars['UUID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  role: UserRoleEnum;
};

export enum UserRoleEnum {
  Admin = 'ADMIN',
  Client = 'CLIENT'
}

export type VirtualComponentDto = {
  __typename?: 'VirtualComponentDto';
  description: Scalars['String']['output'];
  format: ComponentFormatEnum;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  slotName: Scalars['String']['output'];
};

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutations', createLocation: { __typename?: 'LocationByClientIdDto', id: any } };

export type CreateClientMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutations', createClient: { __typename?: 'ClientDto', id: any, name: string } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutations', createUser: { __typename?: 'UserDto', id: any } };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutations', updateLocation: { __typename?: 'LocationByClientIdDto', id: any } };

export type UpdateAlarmMutationVariables = Exact<{
  input: UpdateAlarmInput;
}>;


export type UpdateAlarmMutation = { __typename?: 'Mutations', updateAlarm: { __typename?: 'AlarmDto', id: any } };

export type UpdateAlarmConfigurationMutationVariables = Exact<{
  input: UpdateAlarmConfigurationInput;
}>;


export type UpdateAlarmConfigurationMutation = { __typename?: 'Mutations', updateAlarmConfiguration: { __typename?: 'AlarmConfigurationDto', id: any } };

export type UpdateDistributionBoardsMutationVariables = Exact<{
  input: UpdateDistributionBoardInput;
}>;


export type UpdateDistributionBoardsMutation = { __typename?: 'Mutations', updateDistributionBoard: { __typename?: 'DistributionBoardDto', id: any } };

export type DeleteLocationMutationVariables = Exact<{
  input: Scalars['UUID']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutations', deleteLocation: { __typename?: 'LocationByClientIdDto', id: any } };

export type DeleteClientMutationVariables = Exact<{
  input: Scalars['UUID']['input'];
}>;


export type DeleteClientMutation = { __typename?: 'Mutations', deleteClient: { __typename?: 'ClientDto', id: any } };

export type DeleteUserMutationVariables = Exact<{
  input: Scalars['UUID']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutations', deleteUser: { __typename?: 'UserDto', id: any } };

export type ToggleUserActivationMutationVariables = Exact<{
  input: Scalars['UUID']['input'];
  isActive: Scalars['Boolean']['input'];
}>;


export type ToggleUserActivationMutation = { __typename?: 'Mutations', deactivateUser: { __typename?: 'UserDto', id: any, isActive: boolean } };

export type InviteUserMutationVariables = Exact<{
  input: Scalars['UUID']['input'];
}>;


export type InviteUserMutation = { __typename?: 'Mutations', inviteUser: { __typename?: 'UserDto', id: any } };

export type UpdateDistributionBoardSettingsMutationVariables = Exact<{
  input: UpdateDistributionBoardSettingsInput;
}>;


export type UpdateDistributionBoardSettingsMutation = { __typename?: 'Mutations', updateDistributionBoardSettings: { __typename?: 'DistributionBoardSettingsDto', id: any, sendInterval: number } };

export type GetAlarmsQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
  isAcknowledged?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAlarmsQuery = { __typename?: 'Queries', alarms: Array<{ __typename?: 'AlarmDto', id: any, isActive: boolean, timestamp: any, isAcknowledged: boolean, type: AlarmTypeEnum, code?: string | null, description: { __typename?: 'AlarmDescriptionDto', descriptionArguments?: Array<string> | null, descriptionCode: AlarmDescriptionEnum } }> };

export type GetAlarmsHistoryQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
  slotName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAlarmsHistoryQuery = { __typename?: 'Queries', alarmsHistory: Array<{ __typename?: 'AlarmDto', status: AlarmStatusEnum, id: any, timestamp: any, type: AlarmTypeEnum, code?: string | null, description: { __typename?: 'AlarmDescriptionDto', descriptionArguments?: Array<string> | null, descriptionCode: AlarmDescriptionEnum } }> };

export type GetAlarmComponentsQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetAlarmComponentsQuery = { __typename?: 'Queries', alarmComponents: Array<{ __typename?: 'ComponentDto', slotName: string, description: string }> };

export type GetLocationsQueryVariables = Exact<{
  alarmsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  hasActiveContract?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLocationsQuery = { __typename?: 'Queries', locations: Array<{ __typename?: 'LocationDto', address: string, clientId: any, contractDate: any, distributionBoardId: any, hasActiveContract: boolean, hasAlarm: boolean, mobile: string, id: any, name: string }> };

export type GetAlarmConfigurationsQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetAlarmConfigurationsQuery = { __typename?: 'Queries', alarmConfigurations: Array<{ __typename?: 'AlarmConfigurationDto', id: any, description: string, code?: string | null, slotName?: string | null, alarmType: AlarmTypeEnum, notificationType: NotificationTypeEnum, alarmCondition?: boolean | null, alarmValue?: any | null, alarmMinutesPeriod?: number | null }> };

export type GetProcessedDataHeaderNamesQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetProcessedDataHeaderNamesQuery = { __typename?: 'Queries', processedDataHeaderNames: Array<{ __typename?: 'ComponentDto', slotName: string, description: string }> };

export type GetClientQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Queries', client: { __typename?: 'ClientDto', imageUrl: string, id: any, name: string } };

export type GetClientsQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientsQuery = { __typename?: 'Queries', clients: Array<{ __typename?: 'ClientDto', id: any, name: string, dateCreated: any }> };

export type GetLocationByClientIdQueryVariables = Exact<{
  clientId: Scalars['UUID']['input'];
}>;


export type GetLocationByClientIdQuery = { __typename?: 'Queries', locationsByClientId: Array<{ __typename?: 'LocationByClientIdDto', id: any, address: string, name: string, contractDate: any, distributionBoardId: any, mobile: string }> };

export type GetMetricsQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetMetricsQuery = { __typename?: 'Queries', metric: { __typename?: 'MetricDto', id: any, timestamp: any, enableSaveFunction: boolean, editingEnabled: boolean, firstPackageReceived?: any | null, fistPackageAfterCommunicationRestore?: any | null, distributionBoardId: any, components?: Array<{ __typename?: 'ComponentDto', slotName: string, description: string, isEditable: boolean, value?: string | null, targetValue?: string | null, componentType: ComponentTypeEnum, componentFormat: ComponentFormatEnum, category: CategoryEnum }> | null } };

export type GetHistoriesQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetHistoriesQuery = { __typename?: 'Queries', histories: Array<{ __typename?: 'HistoryDto', id: any, timestamp: any, formattedData?: { __typename?: 'FormattedDataDto', slot1?: string | null, slot2?: string | null, slot3?: string | null, slot4?: string | null, slot5?: string | null, slot6?: string | null, slot7?: string | null, slot8?: string | null, slot9?: string | null, slot10?: string | null, slot11?: string | null, slot12?: string | null, slot13?: string | null, slot14?: string | null, slot15?: string | null, slot16?: string | null, slot17?: string | null, slot18?: string | null, slot19?: string | null, slot20?: string | null, slot21?: string | null, slot22?: string | null, slot23?: string | null, slot24?: string | null, slot25?: string | null, slot26?: string | null, slot27?: string | null, slot28?: string | null, slot29?: string | null, slot30?: string | null, slot31?: string | null, slot32?: string | null, slot33?: string | null, slot34?: string | null, slot35?: string | null, slot36?: string | null, slot37?: string | null, slot38?: string | null, slot39?: string | null, slot40?: string | null, slot41?: string | null, slot42?: string | null, slot43?: string | null, slot44?: string | null, slot45?: string | null, slot46?: string | null, slot47?: string | null, slot48?: string | null, slot49?: string | null, slot50?: string | null, slot51?: string | null, slot52?: string | null, slot53?: string | null, slot54?: string | null, slot55?: string | null, slot56?: string | null, slot57?: string | null, slot58?: string | null, slot59?: string | null, slot60?: string | null, slot61?: string | null, slot62?: string | null, slot63?: string | null, slot64?: string | null, slot65?: string | null, slot66?: string | null, slot67?: string | null, slot68?: string | null, slot69?: string | null, slot70?: string | null, slot71?: string | null, slot72?: string | null, slot73?: string | null, slot74?: string | null, slot75?: string | null, slot76?: string | null, slot77?: string | null, slot78?: string | null, slot79?: string | null, slot80?: string | null, slot81?: string | null, slot82?: string | null, slot83?: string | null, slot84?: string | null, slot85?: string | null, slot86?: string | null, slot87?: string | null, slot88?: string | null, slot89?: string | null, slot90?: string | null, slot91?: string | null, slot92?: string | null, slot93?: string | null, slot94?: string | null, slot95?: string | null, slot96?: string | null, slot97?: string | null, slot98?: string | null, slot99?: string | null, slot100?: string | null, slot101?: string | null, slot102?: string | null, slot103?: string | null, slot104?: string | null, slot105?: string | null, slot106?: string | null, slot107?: string | null, slot108?: string | null, slot109?: string | null, slot110?: string | null, slot111?: string | null, slot112?: string | null, slot113?: string | null } | null }> };

export type GetLocationQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetLocationQuery = { __typename?: 'Queries', location: { __typename?: 'LocationByClientIdDto', id: any, address: string, name: string, contractDate: any, distributionBoardId: any, mobile: string } };

export type GetDistributionBoardQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetDistributionBoardQuery = { __typename?: 'Queries', distributionBoard: { __typename?: 'DistributionBoardDto', communicationModule: CommunicationModuleEnum, id: any, display: DisplayEnum, powerSupply: string, template: TemplateEnum, boardComponents: Array<{ __typename?: 'DistributionBoardComponentDto', connectorCode?: string | null, description: string, factor?: any | null, fuseSpec: string, id: any, channelCode?: string | null, name: string }> } };

export type GetPackageBoardQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetPackageBoardQuery = { __typename?: 'Queries', distributionBoard: { __typename?: 'DistributionBoardDto', id: any, virtualComponents: Array<{ __typename?: 'VirtualComponentDto', description: string, id: any, name: string, slotName: string, format: ComponentFormatEnum }> } };

export type GetUsersQueryVariables = Exact<{
  searchText?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsersQuery = { __typename?: 'Queries', users: Array<{ __typename?: 'UserDto', id: any, name: string, clientId?: any | null, isActive: boolean, isDeleted: boolean, role: UserRoleEnum, email: string, clientName?: string | null }> };

export type GetSettingsBoardQueryVariables = Exact<{
  locationId: Scalars['UUID']['input'];
}>;


export type GetSettingsBoardQuery = { __typename?: 'Queries', distributionBoardSettings: { __typename?: 'DistributionBoardSettingsDto', id: any, emergencyStopPump1: boolean, emergencyStopPump2: boolean, sendInterval: number } };


export const CreateLocationDocument = gql`
    mutation CreateLocation($input: CreateLocationInput!) {
  createLocation(input: $input) {
    id
  }
}
    `;
export type CreateLocationMutationFn = Apollo.MutationFunction<CreateLocationMutation, CreateLocationMutationVariables>;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLocationMutation, { data, loading, error }] = useCreateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLocationMutation, CreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
      }
export type CreateLocationMutationHookResult = ReturnType<typeof useCreateLocationMutation>;
export type CreateLocationMutationResult = Apollo.MutationResult<CreateLocationMutation>;
export type CreateLocationMutationOptions = Apollo.BaseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($input: CreateClientInput!) {
  createClient(input: $input) {
    id
    name
  }
}
    `;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($input: UpdateLocationInput!) {
  updateLocation(input: $input) {
    id
  }
}
    `;
export type UpdateLocationMutationFn = Apollo.MutationFunction<UpdateLocationMutation, UpdateLocationMutationVariables>;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLocationMutation, { data, loading, error }] = useUpdateLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLocationMutation, UpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
      }
export type UpdateLocationMutationHookResult = ReturnType<typeof useUpdateLocationMutation>;
export type UpdateLocationMutationResult = Apollo.MutationResult<UpdateLocationMutation>;
export type UpdateLocationMutationOptions = Apollo.BaseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateAlarmDocument = gql`
    mutation UpdateAlarm($input: UpdateAlarmInput!) {
  updateAlarm(input: $input) {
    id
  }
}
    `;
export type UpdateAlarmMutationFn = Apollo.MutationFunction<UpdateAlarmMutation, UpdateAlarmMutationVariables>;

/**
 * __useUpdateAlarmMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlarmMutation, { data, loading, error }] = useUpdateAlarmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlarmMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlarmMutation, UpdateAlarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlarmMutation, UpdateAlarmMutationVariables>(UpdateAlarmDocument, options);
      }
export type UpdateAlarmMutationHookResult = ReturnType<typeof useUpdateAlarmMutation>;
export type UpdateAlarmMutationResult = Apollo.MutationResult<UpdateAlarmMutation>;
export type UpdateAlarmMutationOptions = Apollo.BaseMutationOptions<UpdateAlarmMutation, UpdateAlarmMutationVariables>;
export const UpdateAlarmConfigurationDocument = gql`
    mutation UpdateAlarmConfiguration($input: UpdateAlarmConfigurationInput!) {
  updateAlarmConfiguration(input: $input) {
    id
  }
}
    `;
export type UpdateAlarmConfigurationMutationFn = Apollo.MutationFunction<UpdateAlarmConfigurationMutation, UpdateAlarmConfigurationMutationVariables>;

/**
 * __useUpdateAlarmConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlarmConfigurationMutation, { data, loading, error }] = useUpdateAlarmConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlarmConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAlarmConfigurationMutation, UpdateAlarmConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAlarmConfigurationMutation, UpdateAlarmConfigurationMutationVariables>(UpdateAlarmConfigurationDocument, options);
      }
export type UpdateAlarmConfigurationMutationHookResult = ReturnType<typeof useUpdateAlarmConfigurationMutation>;
export type UpdateAlarmConfigurationMutationResult = Apollo.MutationResult<UpdateAlarmConfigurationMutation>;
export type UpdateAlarmConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateAlarmConfigurationMutation, UpdateAlarmConfigurationMutationVariables>;
export const UpdateDistributionBoardsDocument = gql`
    mutation UpdateDistributionBoards($input: UpdateDistributionBoardInput!) {
  updateDistributionBoard(input: $input) {
    id
  }
}
    `;
export type UpdateDistributionBoardsMutationFn = Apollo.MutationFunction<UpdateDistributionBoardsMutation, UpdateDistributionBoardsMutationVariables>;

/**
 * __useUpdateDistributionBoardsMutation__
 *
 * To run a mutation, you first call `useUpdateDistributionBoardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributionBoardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributionBoardsMutation, { data, loading, error }] = useUpdateDistributionBoardsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistributionBoardsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributionBoardsMutation, UpdateDistributionBoardsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributionBoardsMutation, UpdateDistributionBoardsMutationVariables>(UpdateDistributionBoardsDocument, options);
      }
export type UpdateDistributionBoardsMutationHookResult = ReturnType<typeof useUpdateDistributionBoardsMutation>;
export type UpdateDistributionBoardsMutationResult = Apollo.MutationResult<UpdateDistributionBoardsMutation>;
export type UpdateDistributionBoardsMutationOptions = Apollo.BaseMutationOptions<UpdateDistributionBoardsMutation, UpdateDistributionBoardsMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($input: UUID!) {
  deleteLocation(id: $input) {
    id
  }
}
    `;
export type DeleteLocationMutationFn = Apollo.MutationFunction<DeleteLocationMutation, DeleteLocationMutationVariables>;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLocationMutation, { data, loading, error }] = useDeleteLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLocationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLocationMutation, DeleteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
      }
export type DeleteLocationMutationHookResult = ReturnType<typeof useDeleteLocationMutation>;
export type DeleteLocationMutationResult = Apollo.MutationResult<DeleteLocationMutation>;
export type DeleteLocationMutationOptions = Apollo.BaseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeleteClientDocument = gql`
    mutation DeleteClient($input: UUID!) {
  deleteClient(id: $input) {
    id
  }
}
    `;
export type DeleteClientMutationFn = Apollo.MutationFunction<DeleteClientMutation, DeleteClientMutationVariables>;

/**
 * __useDeleteClientMutation__
 *
 * To run a mutation, you first call `useDeleteClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientMutation, { data, loading, error }] = useDeleteClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientMutation, DeleteClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientMutation, DeleteClientMutationVariables>(DeleteClientDocument, options);
      }
export type DeleteClientMutationHookResult = ReturnType<typeof useDeleteClientMutation>;
export type DeleteClientMutationResult = Apollo.MutationResult<DeleteClientMutation>;
export type DeleteClientMutationOptions = Apollo.BaseMutationOptions<DeleteClientMutation, DeleteClientMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($input: UUID!) {
  deleteUser(id: $input) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const ToggleUserActivationDocument = gql`
    mutation ToggleUserActivation($input: UUID!, $isActive: Boolean!) {
  deactivateUser(id: $input, isActive: $isActive) {
    id
    isActive
  }
}
    `;
export type ToggleUserActivationMutationFn = Apollo.MutationFunction<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>;

/**
 * __useToggleUserActivationMutation__
 *
 * To run a mutation, you first call `useToggleUserActivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleUserActivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleUserActivationMutation, { data, loading, error }] = useToggleUserActivationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useToggleUserActivationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>(ToggleUserActivationDocument, options);
      }
export type ToggleUserActivationMutationHookResult = ReturnType<typeof useToggleUserActivationMutation>;
export type ToggleUserActivationMutationResult = Apollo.MutationResult<ToggleUserActivationMutation>;
export type ToggleUserActivationMutationOptions = Apollo.BaseMutationOptions<ToggleUserActivationMutation, ToggleUserActivationMutationVariables>;
export const InviteUserDocument = gql`
    mutation InviteUser($input: UUID!) {
  inviteUser(id: $input) {
    id
  }
}
    `;
export type InviteUserMutationFn = Apollo.MutationFunction<InviteUserMutation, InviteUserMutationVariables>;

/**
 * __useInviteUserMutation__
 *
 * To run a mutation, you first call `useInviteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteUserMutation, { data, loading, error }] = useInviteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteUserMutation(baseOptions?: Apollo.MutationHookOptions<InviteUserMutation, InviteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteUserMutation, InviteUserMutationVariables>(InviteUserDocument, options);
      }
export type InviteUserMutationHookResult = ReturnType<typeof useInviteUserMutation>;
export type InviteUserMutationResult = Apollo.MutationResult<InviteUserMutation>;
export type InviteUserMutationOptions = Apollo.BaseMutationOptions<InviteUserMutation, InviteUserMutationVariables>;
export const UpdateDistributionBoardSettingsDocument = gql`
    mutation UpdateDistributionBoardSettings($input: UpdateDistributionBoardSettingsInput!) {
  updateDistributionBoardSettings(input: $input) {
    id
    sendInterval
  }
}
    `;
export type UpdateDistributionBoardSettingsMutationFn = Apollo.MutationFunction<UpdateDistributionBoardSettingsMutation, UpdateDistributionBoardSettingsMutationVariables>;

/**
 * __useUpdateDistributionBoardSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateDistributionBoardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributionBoardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributionBoardSettingsMutation, { data, loading, error }] = useUpdateDistributionBoardSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistributionBoardSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributionBoardSettingsMutation, UpdateDistributionBoardSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributionBoardSettingsMutation, UpdateDistributionBoardSettingsMutationVariables>(UpdateDistributionBoardSettingsDocument, options);
      }
export type UpdateDistributionBoardSettingsMutationHookResult = ReturnType<typeof useUpdateDistributionBoardSettingsMutation>;
export type UpdateDistributionBoardSettingsMutationResult = Apollo.MutationResult<UpdateDistributionBoardSettingsMutation>;
export type UpdateDistributionBoardSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateDistributionBoardSettingsMutation, UpdateDistributionBoardSettingsMutationVariables>;
export const GetAlarmsDocument = gql`
    query GetAlarms($locationId: UUID!, $isAcknowledged: Boolean) {
  alarms(locationId: $locationId, isAcknowledged: $isAcknowledged) {
    description {
      descriptionArguments
      descriptionCode
    }
    id
    isActive
    timestamp
    isAcknowledged
    type
    code
  }
}
    `;

/**
 * __useGetAlarmsQuery__
 *
 * To run a query within a React component, call `useGetAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      isAcknowledged: // value for 'isAcknowledged'
 *   },
 * });
 */
export function useGetAlarmsQuery(baseOptions: Apollo.QueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmsQuery, GetAlarmsQueryVariables>(GetAlarmsDocument, options);
      }
export function useGetAlarmsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmsQuery, GetAlarmsQueryVariables>(GetAlarmsDocument, options);
        }
export function useGetAlarmsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlarmsQuery, GetAlarmsQueryVariables>(GetAlarmsDocument, options);
        }
export type GetAlarmsQueryHookResult = ReturnType<typeof useGetAlarmsQuery>;
export type GetAlarmsLazyQueryHookResult = ReturnType<typeof useGetAlarmsLazyQuery>;
export type GetAlarmsSuspenseQueryHookResult = ReturnType<typeof useGetAlarmsSuspenseQuery>;
export type GetAlarmsQueryResult = Apollo.QueryResult<GetAlarmsQuery, GetAlarmsQueryVariables>;
export const GetAlarmsHistoryDocument = gql`
    query GetAlarmsHistory($locationId: UUID!, $slotName: String) {
  alarmsHistory(locationId: $locationId, slotName: $slotName) {
    description {
      descriptionArguments
      descriptionCode
    }
    status
    id
    timestamp
    type
    code
  }
}
    `;

/**
 * __useGetAlarmsHistoryQuery__
 *
 * To run a query within a React component, call `useGetAlarmsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmsHistoryQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      slotName: // value for 'slotName'
 *   },
 * });
 */
export function useGetAlarmsHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>(GetAlarmsHistoryDocument, options);
      }
export function useGetAlarmsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>(GetAlarmsHistoryDocument, options);
        }
export function useGetAlarmsHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>(GetAlarmsHistoryDocument, options);
        }
export type GetAlarmsHistoryQueryHookResult = ReturnType<typeof useGetAlarmsHistoryQuery>;
export type GetAlarmsHistoryLazyQueryHookResult = ReturnType<typeof useGetAlarmsHistoryLazyQuery>;
export type GetAlarmsHistorySuspenseQueryHookResult = ReturnType<typeof useGetAlarmsHistorySuspenseQuery>;
export type GetAlarmsHistoryQueryResult = Apollo.QueryResult<GetAlarmsHistoryQuery, GetAlarmsHistoryQueryVariables>;
export const GetAlarmComponentsDocument = gql`
    query GetAlarmComponents($locationId: UUID!) {
  alarmComponents(locationId: $locationId) {
    slotName
    description
  }
}
    `;

/**
 * __useGetAlarmComponentsQuery__
 *
 * To run a query within a React component, call `useGetAlarmComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmComponentsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetAlarmComponentsQuery(baseOptions: Apollo.QueryHookOptions<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>(GetAlarmComponentsDocument, options);
      }
export function useGetAlarmComponentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>(GetAlarmComponentsDocument, options);
        }
export function useGetAlarmComponentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>(GetAlarmComponentsDocument, options);
        }
export type GetAlarmComponentsQueryHookResult = ReturnType<typeof useGetAlarmComponentsQuery>;
export type GetAlarmComponentsLazyQueryHookResult = ReturnType<typeof useGetAlarmComponentsLazyQuery>;
export type GetAlarmComponentsSuspenseQueryHookResult = ReturnType<typeof useGetAlarmComponentsSuspenseQuery>;
export type GetAlarmComponentsQueryResult = Apollo.QueryResult<GetAlarmComponentsQuery, GetAlarmComponentsQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations($alarmsOnly: Boolean, $searchText: String, $hasActiveContract: Boolean) {
  locations(
    alarmsOnly: $alarmsOnly
    searchText: $searchText
    hasActiveContract: $hasActiveContract
  ) {
    address
    clientId
    contractDate
    distributionBoardId
    hasActiveContract
    hasAlarm
    mobile
    id
    name
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      alarmsOnly: // value for 'alarmsOnly'
 *      searchText: // value for 'searchText'
 *      hasActiveContract: // value for 'hasActiveContract'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export function useGetLocationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsSuspenseQueryHookResult = ReturnType<typeof useGetLocationsSuspenseQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetAlarmConfigurationsDocument = gql`
    query GetAlarmConfigurations($locationId: UUID!) {
  alarmConfigurations(locationId: $locationId) {
    id
    description
    code
    slotName
    alarmType
    notificationType
    alarmCondition
    alarmValue
    alarmMinutesPeriod
  }
}
    `;

/**
 * __useGetAlarmConfigurationsQuery__
 *
 * To run a query within a React component, call `useGetAlarmConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmConfigurationsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetAlarmConfigurationsQuery(baseOptions: Apollo.QueryHookOptions<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>(GetAlarmConfigurationsDocument, options);
      }
export function useGetAlarmConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>(GetAlarmConfigurationsDocument, options);
        }
export function useGetAlarmConfigurationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>(GetAlarmConfigurationsDocument, options);
        }
export type GetAlarmConfigurationsQueryHookResult = ReturnType<typeof useGetAlarmConfigurationsQuery>;
export type GetAlarmConfigurationsLazyQueryHookResult = ReturnType<typeof useGetAlarmConfigurationsLazyQuery>;
export type GetAlarmConfigurationsSuspenseQueryHookResult = ReturnType<typeof useGetAlarmConfigurationsSuspenseQuery>;
export type GetAlarmConfigurationsQueryResult = Apollo.QueryResult<GetAlarmConfigurationsQuery, GetAlarmConfigurationsQueryVariables>;
export const GetProcessedDataHeaderNamesDocument = gql`
    query GetProcessedDataHeaderNames($locationId: UUID!) {
  processedDataHeaderNames(locationId: $locationId) {
    slotName
    description
  }
}
    `;

/**
 * __useGetProcessedDataHeaderNamesQuery__
 *
 * To run a query within a React component, call `useGetProcessedDataHeaderNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProcessedDataHeaderNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProcessedDataHeaderNamesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetProcessedDataHeaderNamesQuery(baseOptions: Apollo.QueryHookOptions<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>(GetProcessedDataHeaderNamesDocument, options);
      }
export function useGetProcessedDataHeaderNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>(GetProcessedDataHeaderNamesDocument, options);
        }
export function useGetProcessedDataHeaderNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>(GetProcessedDataHeaderNamesDocument, options);
        }
export type GetProcessedDataHeaderNamesQueryHookResult = ReturnType<typeof useGetProcessedDataHeaderNamesQuery>;
export type GetProcessedDataHeaderNamesLazyQueryHookResult = ReturnType<typeof useGetProcessedDataHeaderNamesLazyQuery>;
export type GetProcessedDataHeaderNamesSuspenseQueryHookResult = ReturnType<typeof useGetProcessedDataHeaderNamesSuspenseQuery>;
export type GetProcessedDataHeaderNamesQueryResult = Apollo.QueryResult<GetProcessedDataHeaderNamesQuery, GetProcessedDataHeaderNamesQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($id: UUID!) {
  client(id: $id) {
    imageUrl
    id
    name
  }
}
    `;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientsDocument = gql`
    query GetClients($searchText: String) {
  clients(searchText: $searchText) {
    id
    name
    dateCreated
  }
}
    `;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetLocationByClientIdDocument = gql`
    query GetLocationByClientId($clientId: UUID!) {
  locationsByClientId(clientId: $clientId) {
    id
    address
    name
    contractDate
    distributionBoardId
    mobile
  }
}
    `;

/**
 * __useGetLocationByClientIdQuery__
 *
 * To run a query within a React component, call `useGetLocationByClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationByClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationByClientIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetLocationByClientIdQuery(baseOptions: Apollo.QueryHookOptions<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>(GetLocationByClientIdDocument, options);
      }
export function useGetLocationByClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>(GetLocationByClientIdDocument, options);
        }
export function useGetLocationByClientIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>(GetLocationByClientIdDocument, options);
        }
export type GetLocationByClientIdQueryHookResult = ReturnType<typeof useGetLocationByClientIdQuery>;
export type GetLocationByClientIdLazyQueryHookResult = ReturnType<typeof useGetLocationByClientIdLazyQuery>;
export type GetLocationByClientIdSuspenseQueryHookResult = ReturnType<typeof useGetLocationByClientIdSuspenseQuery>;
export type GetLocationByClientIdQueryResult = Apollo.QueryResult<GetLocationByClientIdQuery, GetLocationByClientIdQueryVariables>;
export const GetMetricsDocument = gql`
    query GetMetrics($locationId: UUID!) {
  metric(locationId: $locationId) {
    id
    timestamp
    enableSaveFunction
    editingEnabled
    components {
      slotName
      description
      isEditable
      value
      targetValue
      componentType
      componentFormat
      category
    }
    firstPackageReceived
    fistPackageAfterCommunicationRestore
    distributionBoardId
  }
}
    `;

/**
 * __useGetMetricsQuery__
 *
 * To run a query within a React component, call `useGetMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsQuery, GetMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsQuery, GetMetricsQueryVariables>(GetMetricsDocument, options);
      }
export function useGetMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsQuery, GetMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsQuery, GetMetricsQueryVariables>(GetMetricsDocument, options);
        }
export function useGetMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMetricsQuery, GetMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricsQuery, GetMetricsQueryVariables>(GetMetricsDocument, options);
        }
export type GetMetricsQueryHookResult = ReturnType<typeof useGetMetricsQuery>;
export type GetMetricsLazyQueryHookResult = ReturnType<typeof useGetMetricsLazyQuery>;
export type GetMetricsSuspenseQueryHookResult = ReturnType<typeof useGetMetricsSuspenseQuery>;
export type GetMetricsQueryResult = Apollo.QueryResult<GetMetricsQuery, GetMetricsQueryVariables>;
export const GetHistoriesDocument = gql`
    query GetHistories($locationId: UUID!, $fromDate: DateTime, $toDate: DateTime) {
  histories(locationId: $locationId, fromDate: $fromDate, toDate: $toDate) {
    id
    timestamp
    formattedData {
      slot1
      slot2
      slot3
      slot4
      slot5
      slot6
      slot7
      slot8
      slot9
      slot10
      slot11
      slot12
      slot13
      slot14
      slot15
      slot16
      slot17
      slot18
      slot19
      slot20
      slot21
      slot22
      slot23
      slot24
      slot25
      slot26
      slot27
      slot28
      slot29
      slot30
      slot31
      slot32
      slot33
      slot34
      slot35
      slot36
      slot37
      slot38
      slot39
      slot40
      slot41
      slot42
      slot43
      slot44
      slot45
      slot46
      slot47
      slot48
      slot49
      slot50
      slot51
      slot52
      slot53
      slot54
      slot55
      slot56
      slot57
      slot58
      slot59
      slot60
      slot61
      slot62
      slot63
      slot64
      slot65
      slot66
      slot67
      slot68
      slot69
      slot70
      slot71
      slot72
      slot73
      slot74
      slot75
      slot76
      slot77
      slot78
      slot79
      slot80
      slot81
      slot82
      slot83
      slot84
      slot85
      slot86
      slot87
      slot88
      slot89
      slot90
      slot91
      slot92
      slot93
      slot94
      slot95
      slot96
      slot97
      slot98
      slot99
      slot100
      slot101
      slot102
      slot103
      slot104
      slot105
      slot106
      slot107
      slot108
      slot109
      slot110
      slot111
      slot112
      slot113
    }
  }
}
    `;

/**
 * __useGetHistoriesQuery__
 *
 * To run a query within a React component, call `useGetHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHistoriesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function useGetHistoriesQuery(baseOptions: Apollo.QueryHookOptions<GetHistoriesQuery, GetHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHistoriesQuery, GetHistoriesQueryVariables>(GetHistoriesDocument, options);
      }
export function useGetHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHistoriesQuery, GetHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHistoriesQuery, GetHistoriesQueryVariables>(GetHistoriesDocument, options);
        }
export function useGetHistoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHistoriesQuery, GetHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHistoriesQuery, GetHistoriesQueryVariables>(GetHistoriesDocument, options);
        }
export type GetHistoriesQueryHookResult = ReturnType<typeof useGetHistoriesQuery>;
export type GetHistoriesLazyQueryHookResult = ReturnType<typeof useGetHistoriesLazyQuery>;
export type GetHistoriesSuspenseQueryHookResult = ReturnType<typeof useGetHistoriesSuspenseQuery>;
export type GetHistoriesQueryResult = Apollo.QueryResult<GetHistoriesQuery, GetHistoriesQueryVariables>;
export const GetLocationDocument = gql`
    query GetLocation($locationId: UUID!) {
  location(locationId: $locationId) {
    id
    address
    name
    contractDate
    distributionBoardId
    mobile
  }
}
    `;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export function useGetLocationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationSuspenseQueryHookResult = ReturnType<typeof useGetLocationSuspenseQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export const GetDistributionBoardDocument = gql`
    query GetDistributionBoard($locationId: UUID!) {
  distributionBoard(locationId: $locationId) {
    boardComponents {
      connectorCode
      description
      factor
      fuseSpec
      id
      channelCode
      name
    }
    communicationModule
    id
    display
    powerSupply
    template
  }
}
    `;

/**
 * __useGetDistributionBoardQuery__
 *
 * To run a query within a React component, call `useGetDistributionBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributionBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributionBoardQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetDistributionBoardQuery(baseOptions: Apollo.QueryHookOptions<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>(GetDistributionBoardDocument, options);
      }
export function useGetDistributionBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>(GetDistributionBoardDocument, options);
        }
export function useGetDistributionBoardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>(GetDistributionBoardDocument, options);
        }
export type GetDistributionBoardQueryHookResult = ReturnType<typeof useGetDistributionBoardQuery>;
export type GetDistributionBoardLazyQueryHookResult = ReturnType<typeof useGetDistributionBoardLazyQuery>;
export type GetDistributionBoardSuspenseQueryHookResult = ReturnType<typeof useGetDistributionBoardSuspenseQuery>;
export type GetDistributionBoardQueryResult = Apollo.QueryResult<GetDistributionBoardQuery, GetDistributionBoardQueryVariables>;
export const GetPackageBoardDocument = gql`
    query GetPackageBoard($locationId: UUID!) {
  distributionBoard(locationId: $locationId) {
    virtualComponents {
      description
      id
      name
      slotName
      format
    }
    id
  }
}
    `;

/**
 * __useGetPackageBoardQuery__
 *
 * To run a query within a React component, call `useGetPackageBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackageBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackageBoardQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetPackageBoardQuery(baseOptions: Apollo.QueryHookOptions<GetPackageBoardQuery, GetPackageBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackageBoardQuery, GetPackageBoardQueryVariables>(GetPackageBoardDocument, options);
      }
export function useGetPackageBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackageBoardQuery, GetPackageBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackageBoardQuery, GetPackageBoardQueryVariables>(GetPackageBoardDocument, options);
        }
export function useGetPackageBoardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPackageBoardQuery, GetPackageBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPackageBoardQuery, GetPackageBoardQueryVariables>(GetPackageBoardDocument, options);
        }
export type GetPackageBoardQueryHookResult = ReturnType<typeof useGetPackageBoardQuery>;
export type GetPackageBoardLazyQueryHookResult = ReturnType<typeof useGetPackageBoardLazyQuery>;
export type GetPackageBoardSuspenseQueryHookResult = ReturnType<typeof useGetPackageBoardSuspenseQuery>;
export type GetPackageBoardQueryResult = Apollo.QueryResult<GetPackageBoardQuery, GetPackageBoardQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($searchText: String) {
  users(searchText: $searchText) {
    id
    name
    clientId
    isActive
    isDeleted
    role
    email
    clientName
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      searchText: // value for 'searchText'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetSettingsBoardDocument = gql`
    query GetSettingsBoard($locationId: UUID!) {
  distributionBoardSettings(locationId: $locationId) {
    id
    emergencyStopPump1
    emergencyStopPump2
    sendInterval
  }
}
    `;

/**
 * __useGetSettingsBoardQuery__
 *
 * To run a query within a React component, call `useGetSettingsBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSettingsBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSettingsBoardQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetSettingsBoardQuery(baseOptions: Apollo.QueryHookOptions<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>(GetSettingsBoardDocument, options);
      }
export function useGetSettingsBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>(GetSettingsBoardDocument, options);
        }
export function useGetSettingsBoardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>(GetSettingsBoardDocument, options);
        }
export type GetSettingsBoardQueryHookResult = ReturnType<typeof useGetSettingsBoardQuery>;
export type GetSettingsBoardLazyQueryHookResult = ReturnType<typeof useGetSettingsBoardLazyQuery>;
export type GetSettingsBoardSuspenseQueryHookResult = ReturnType<typeof useGetSettingsBoardSuspenseQuery>;
export type GetSettingsBoardQueryResult = Apollo.QueryResult<GetSettingsBoardQuery, GetSettingsBoardQueryVariables>;